import { AirplaneTakeoff, Clock, Shield, Star, Car, Suitcase } from "@phosphor-icons/react";
import DestinationPage from "./DestinationPage";

const makeSchema = (name, description, url) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": name,
  "description": description,
  "url": url,
  "provider": {
    "@type": "LocalBusiness",
    "name": "ALTURA Conciergerie",
    "telephone": "+33681969342",
    "address": { "@type": "PostalAddress", "addressLocality": "Paris", "addressCountry": "FR" }
  },
  "areaServed": { "@type": "City", "name": "Paris" },
});

// ═══════════════════════════════════════════
// CDG
// ═══════════════════════════════════════════
export const TransfertCDGPage = () => (
  <DestinationPage config={{
    slug: "transfert-aeroport-cdg",
    title: "Chauffeur Privé Aéroport CDG | Transfert Paris-Roissy | ALTURA",
    h1: "Transfert aéroport Charles de Gaulle",
    subtitle: "ALTURA · Chauffeur privé Paris-CDG",
    heroImage: "https://customer-assets.emergentagent.com/job_parisgo/artifacts/8up45an8_8CF1CAA1-D304-4DC3-99AE-C4B9AE562F84.jpeg",
    intro: "Réservez votre chauffeur privé pour un transfert entre Paris et l'aéroport Charles de Gaulle (CDG). ALTURA vous propose un service de transport haut de gamme avec des véhicules Mercedes et Range Rover, disponible 24h/24. Votre chauffeur vous attend dans le hall d'arrivée avec une pancarte à votre nom, prend en charge vos bagages et vous conduit à destination dans le plus grand confort. Que vous voyagiez pour affaires ou pour le plaisir, notre service de transfert aéroport CDG est conçu pour une expérience sans stress.",
    prices: [
      { vehicle: "Mercedes Classe E", capacity: "3 passagers", price: "À partir de 120€" },
      { vehicle: "Mercedes Classe V", capacity: "7 passagers", price: "À partir de 140€" },
      { vehicle: "Mercedes Classe S", capacity: "3 passagers", price: "À partir de 180€" },
    ],
    sections: [
      {
        icon: <AirplaneTakeoff size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Accueil personnalisé en terminal",
        content: "Votre chauffeur ALTURA vous accueille directement dans le terminal d'arrivée de l'aéroport CDG avec une pancarte à votre nom. Il suit votre vol en temps réel et adapte son heure d'arrivée en cas de retard, sans surcoût. Assistance bagages incluse jusqu'au véhicule.",
        list: [
          "Suivi de vol en temps réel — adaptation automatique en cas de retard",
          "Accueil en terminal avec pancarte nominative",
          "Prise en charge des bagages jusqu'au véhicule",
          "30 minutes d'attente offertes après l'atterrissage",
        ],
      },
      {
        icon: <Car size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Véhicules premium pour votre transfert CDG",
        content: "Notre flotte de véhicules haut de gamme est spécialement sélectionnée pour les transferts aéroport. Chaque véhicule est équipé de sièges en cuir, climatisation, Wi-Fi et chargeurs pour vos appareils. Espace bagages généreux pour accueillir vos valises en toute sérénité.",
        list: [
          "Mercedes Classe E — Berline élégante, idéale pour 1 à 3 passagers",
          "Mercedes Classe V — Van de luxe spacieux, parfait pour les familles ou groupes jusqu'à 7 passagers",
          "Mercedes Classe S — Berline de prestige pour un confort absolu",
          "Range Rover, Classe G, Maybach — disponibles sur devis",
        ],
      },
      {
        icon: <Clock size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Service 24h/24 — Vols matinaux et tardifs",
        content: "Que votre vol atterrisse à 5h du matin ou décolle à minuit, ALTURA est disponible à toute heure. Nos chauffeurs connaissent parfaitement les accès aux différents terminaux de Roissy-CDG (Terminal 1, 2A-2G, 3) et les itinéraires les plus rapides selon les conditions de circulation.",
      },
      {
        icon: <Shield size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Trajet Paris-CDG : ce qu'il faut savoir",
        content: "L'aéroport Charles de Gaulle se situe à environ 30 km au nord-est de Paris. Le trajet dure entre 35 minutes et 1h15 selon le trafic et votre point de départ dans Paris. Nous recommandons de prévoir un départ 2h30 avant votre heure d'embarquement pour les vols internationaux et 2h pour les vols domestiques ou européens.",
        list: [
          "Distance depuis Paris centre : ~30 km (35 min à 1h15 de trajet)",
          "Depuis Paris Rive Gauche : compter 45 min à 1h15",
          "Depuis La Défense : compter 25 min à 45 min",
          "Tarif fixe — pas de mauvaise surprise liée aux embouteillages",
        ],
      },
    ],
    faq: [
      { q: "Combien coûte un transfert Paris-CDG en chauffeur privé ?", a: "Les tarifs ALTURA débutent à 120€ pour une Mercedes Classe E, 140€ pour une Classe V et 180€ pour une Classe S. Le tarif est fixe, sans supplément en cas d'embouteillage." },
      { q: "Combien de temps dure le trajet Paris-CDG ?", a: "Le trajet dure entre 35 minutes et 1h15 selon votre point de départ dans Paris et les conditions de circulation. Nous recommandons de prévoir une marge confortable." },
      { q: "Mon vol a du retard, y a-t-il un surcoût ?", a: "Non, votre chauffeur suit votre vol en temps réel et s'adapte sans frais supplémentaires. 30 minutes d'attente sont offertes après l'heure d'atterrissage effective." },
      { q: "Puis-je réserver un transfert CDG à 4h du matin ?", a: "Oui, ALTURA est disponible 24h/24, 7j/7, y compris les jours fériés. Aucun supplément de nuit n'est appliqué." },
    ],
    schema: makeSchema("Transfert Aéroport CDG Paris — Chauffeur Privé", "Service de transfert en chauffeur privé entre Paris et l'aéroport Charles de Gaulle (CDG). Mercedes Classe E, S, V. À partir de 120€. Disponible 24h/24.", "https://alturaconciergerie.com/transfert-aeroport-cdg"),
  }} />
);

// ═══════════════════════════════════════════
// ORLY
// ═══════════════════════════════════════════
export const TransfertOrlyPage = () => (
  <DestinationPage config={{
    slug: "transfert-aeroport-orly",
    title: "Chauffeur Privé Aéroport Orly | Transfert Paris-Orly | ALTURA",
    h1: "Transfert aéroport Paris-Orly",
    subtitle: "ALTURA · Chauffeur privé Paris-Orly",
    heroImage: "https://customer-assets.emergentagent.com/job_parisgo/artifacts/stw5s5ky_703D55C7-6491-4A1D-BBD1-3724BB576F38.png",
    intro: "Réservez votre transfert en chauffeur privé entre Paris et l'aéroport d'Orly. Situé au sud de Paris, Orly est le deuxième aéroport de la capitale et dessert de nombreuses destinations en France, en Europe et vers l'Afrique. ALTURA vous propose un service de transport premium avec accueil en terminal, suivi de vol et véhicules haut de gamme. Profitez d'un trajet serein et ponctuel, que ce soit pour un départ ou une arrivée.",
    prices: [
      { vehicle: "Mercedes Classe E", capacity: "3 passagers", price: "À partir de 120€" },
      { vehicle: "Mercedes Classe V", capacity: "7 passagers", price: "À partir de 140€" },
      { vehicle: "Mercedes Classe S", capacity: "3 passagers", price: "À partir de 180€" },
    ],
    sections: [
      {
        icon: <AirplaneTakeoff size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Accueil à l'aéroport d'Orly",
        content: "Votre chauffeur ALTURA vous attend dans le hall d'arrivée de votre terminal (Orly 1 à 4) avec une pancarte à votre nom. Le suivi de vol est assuré en temps réel pour s'adapter aux éventuels retards sans frais supplémentaires.",
        list: [
          "Accueil personnalisé dans le hall d'arrivée",
          "Couverture de tous les terminaux : Orly 1, 2, 3 et 4",
          "Suivi de vol et adaptation en cas de retard",
          "Prise en charge complète de vos bagages",
        ],
      },
      {
        icon: <Clock size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Trajet Paris-Orly : durée et itinéraire",
        content: "L'aéroport d'Orly est situé à environ 15 km au sud de Paris. Le trajet dure entre 20 et 45 minutes selon le trafic et votre point de départ. C'est l'aéroport le plus proche de Paris, ce qui en fait une option pratique pour les voyageurs pressés.",
        list: [
          "Distance depuis Paris centre : ~15 km (20 à 45 min de trajet)",
          "Depuis le Quartier Latin / Montparnasse : 20 à 30 min",
          "Depuis les Champs-Élysées : 30 à 45 min",
          "Tarif forfaitaire fixe, sans surprise",
        ],
      },
      {
        icon: <Suitcase size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Idéal pour les voyages d'affaires",
        content: "Orly accueille de nombreux vols domestiques et européens. Pour vos déplacements professionnels, ALTURA garantit un service ponctuel et discret. Travaillez dans le calme de votre véhicule avec le Wi-Fi embarqué, ou détendez-vous après un vol dans le confort d'une Mercedes Classe S.",
      },
    ],
    faq: [
      { q: "Combien coûte un transfert Paris-Orly ?", a: "Les tarifs débutent à 120€ pour une Mercedes Classe E, 140€ pour une Classe V et 180€ pour une Classe S. Tarif fixe garanti." },
      { q: "Combien de temps dure le trajet Paris-Orly ?", a: "Le trajet dure entre 20 et 45 minutes selon votre point de départ et le trafic. Orly est l'aéroport le plus proche de Paris." },
      { q: "Quels terminaux sont couverts à Orly ?", a: "Nous couvrons l'ensemble des terminaux de l'aéroport d'Orly : Orly 1, 2, 3 et 4. Votre chauffeur vous accueille directement dans le hall d'arrivée." },
    ],
    schema: makeSchema("Transfert Aéroport Orly Paris — Chauffeur Privé", "Service de transfert en chauffeur privé entre Paris et l'aéroport d'Orly. Mercedes Classe E, S, V. À partir de 120€. Disponible 24h/24.", "https://alturaconciergerie.com/transfert-aeroport-orly"),
  }} />
);

// ═══════════════════════════════════════════
// DISNEYLAND
// ═══════════════════════════════════════════
export const TransfertDisneylandPage = () => (
  <DestinationPage config={{
    slug: "chauffeur-prive-disneyland",
    title: "Chauffeur Privé Disneyland Paris | Transfert VTC | ALTURA",
    h1: "Chauffeur privé pour Disneyland Paris",
    subtitle: "ALTURA · Transfert Disneyland Paris",
    heroImage: "https://customer-assets.emergentagent.com/job_parisgo/artifacts/bat48e3f_E8F9F042-84D5-4B63-87E0-68156E0CD47E.png",
    intro: "Offrez-vous un transfert premium vers Disneyland Paris avec ALTURA. Que vous veniez de Paris, d'un aéroport ou d'une gare, notre service de chauffeur privé vous conduit directement à l'entrée des parcs dans le confort d'un véhicule haut de gamme. Idéal pour les familles avec enfants, les groupes ou les voyageurs en quête de confort. Le Mercedes Classe V peut accueillir jusqu'à 7 passagers avec leurs bagages.",
    prices: [
      { vehicle: "Mercedes Classe E", capacity: "3 passagers", price: "110€" },
      { vehicle: "Mercedes Classe V", capacity: "7 passagers", price: "130€" },
      { vehicle: "Mercedes Classe S", capacity: "3 passagers", price: "180€" },
    ],
    sections: [
      {
        icon: <Star size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Un transfert magique dès le départ",
        content: "Le séjour à Disneyland commence dès que vous montez à bord. Nos chauffeurs professionnels assurent un trajet calme et agréable, idéal pour les familles avec de jeunes enfants. Sièges enfants disponibles sur demande. Vos valises sont prises en charge, vous n'avez qu'à profiter du trajet.",
        list: [
          "Prise en charge à votre hôtel, domicile, gare ou aéroport",
          "Sièges enfants (rehausseur / siège bébé) disponibles sur demande",
          "Véhicules spacieux avec grand coffre pour les bagages et poussettes",
          "Dépose directe à l'entrée des parcs ou de votre hôtel Disney",
        ],
      },
      {
        icon: <Car size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Le Classe V : idéal pour les familles",
        content: "Le Mercedes Classe V est le véhicule parfait pour un transfert Disneyland en famille. Avec ses 7 places passagers et son coffre généreux, il peut accueillir toute la famille et ses bagages dans un confort absolu. Climatisation individuelle, sièges en cuir, Wi-Fi embarqué.",
      },
      {
        icon: <Clock size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Trajet Paris-Disneyland : informations pratiques",
        content: "Disneyland Paris est situé à Marne-la-Vallée, à environ 40 km à l'est de Paris. Le trajet dure entre 40 minutes et 1h15 selon le point de départ et le trafic. Depuis l'aéroport CDG, compter environ 45 minutes.",
        list: [
          "Distance depuis Paris centre : ~40 km (40 min à 1h15)",
          "Depuis l'aéroport CDG : ~45 min",
          "Depuis l'aéroport d'Orly : ~50 min à 1h",
          "Forfait fixe, quelle que soit la durée du trajet",
        ],
      },
    ],
    faq: [
      { q: "Combien coûte un transfert Paris-Disneyland en chauffeur privé ?", a: "Le forfait démarre à 110€ pour une Mercedes Classe E (3 passagers), 130€ pour une Classe V (7 passagers) et 180€ pour une Classe S. Tarif fixe tout compris." },
      { q: "Peut-on avoir des sièges enfants ?", a: "Oui, des sièges enfants (rehausseur ou siège bébé) sont disponibles gratuitement sur demande lors de la réservation." },
      { q: "Le chauffeur peut-il nous attendre à Disneyland ?", a: "Oui, vous pouvez réserver une mise à disposition à l'heure pour que votre chauffeur reste sur place et vous ramène à la fin de votre journée." },
    ],
    schema: makeSchema("Chauffeur Privé Disneyland Paris — Transfert VTC", "Service de transfert en chauffeur privé vers Disneyland Paris. Idéal pour les familles. Mercedes Classe V 7 places. À partir de 110€.", "https://alturaconciergerie.com/chauffeur-prive-disneyland"),
  }} />
);

// ═══════════════════════════════════════════
// VERSAILLES
// ═══════════════════════════════════════════
export const TransfertVersaillesPage = () => (
  <DestinationPage config={{
    slug: "chauffeur-prive-versailles",
    title: "Chauffeur Privé Château de Versailles | Transfert VTC | ALTURA",
    h1: "Chauffeur privé pour le Château de Versailles",
    subtitle: "ALTURA · Transfert Versailles",
    heroImage: "https://customer-assets.emergentagent.com/job_parisgo/artifacts/nvf2ktbp_A218CC23-6605-4A15-A797-D5667A10ABE1.png",
    intro: "Visitez le Château de Versailles avec le confort d'un chauffeur privé ALTURA. Notre service de transfert premium vous conduit directement depuis Paris, votre hôtel ou un aéroport jusqu'aux portes du Château. Profitez d'un trajet serein et d'un retour à l'heure qui vous convient. Pour une journée complète, optez pour notre mise à disposition : votre chauffeur vous attend sur place pendant votre visite.",
    prices: [
      { vehicle: "Mercedes Classe E", capacity: "3 passagers", price: "100€" },
      { vehicle: "Mercedes Classe V", capacity: "7 passagers", price: "120€" },
      { vehicle: "Mercedes Classe S", capacity: "3 passagers", price: "170€" },
    ],
    sections: [
      {
        icon: <Star size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Une visite royale, du début à la fin",
        content: "Le Château de Versailles mérite un écrin à la hauteur. Votre chauffeur ALTURA vous dépose à l'entrée du Château et peut vous attendre sur place pendant toute la durée de votre visite. Idéal pour les touristes de passage à Paris, les séminaires d'entreprise ou les journées culturelles en famille.",
        list: [
          "Dépose directe devant l'entrée du Château",
          "Option mise à disposition : votre chauffeur vous attend sur place",
          "Possibilité de visiter les Jardins et le Grand Trianon",
          "Retour à l'heure de votre choix",
        ],
      },
      {
        icon: <Clock size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Trajet Paris-Versailles : informations pratiques",
        content: "Le Château de Versailles se situe à environ 20 km au sud-ouest de Paris. Le trajet dure entre 30 et 50 minutes selon le trafic. Nous recommandons un départ tôt le matin pour profiter du Château avant l'affluence.",
        list: [
          "Distance depuis Paris centre : ~20 km (30 à 50 min)",
          "Depuis les Champs-Élysées : ~30 min",
          "Depuis l'aéroport CDG : ~1h",
          "Forfait fixe depuis Paris, tarif au km depuis d'autres adresses",
        ],
      },
      {
        icon: <Shield size={24} weight="thin" className="text-[#1A1A1A]" />,
        title: "Mise à disposition pour la journée",
        content: "Pour profiter pleinement de Versailles, optez pour une mise à disposition. Votre chauffeur vous accompagne toute la journée : aller, attente sur place et retour. Vous pouvez également inclure d'autres arrêts (restaurant, shopping) dans votre programme. Tarifs à partir de 70€/h pour une Classe E.",
      },
    ],
    faq: [
      { q: "Combien coûte un transfert Paris-Versailles ?", a: "Le forfait démarre à 100€ pour une Mercedes Classe E, 120€ pour une Classe V et 170€ pour une Classe S. Trajet aller simple depuis Paris." },
      { q: "Le chauffeur peut-il nous attendre pendant la visite ?", a: "Oui, c'est l'option mise à disposition. Votre chauffeur reste sur place et vous ramène quand vous le souhaitez. Comptez environ 3 à 4 heures pour une visite complète." },
      { q: "Peut-on combiner Versailles avec une autre visite ?", a: "Absolument. Avec la mise à disposition, vous pouvez ajouter des arrêts : déjeuner, shopping, visite du Grand Trianon ou des jardins. Votre chauffeur s'adapte à votre programme." },
    ],
    schema: makeSchema("Chauffeur Privé Château de Versailles — Transfert VTC", "Service de transfert en chauffeur privé vers le Château de Versailles depuis Paris. Mercedes Classe E, S, V. À partir de 100€.", "https://alturaconciergerie.com/chauffeur-prive-versailles"),
  }} />
);
